import { css } from '@linaria/core';
import { Grid, Modal, ModalProps } from 'antd';
import classNames from 'classnames';
import { createElement } from 'react';

const styles = {
  fullscreenWrap: css`
    overflow: hidden;
  `,
  modal: css`
    .ant-modal-container {
      padding: 0px;
    }

    .ant-modal-header,
    .ant-modal-body,
    .ant-modal-footer {
      padding: var(--ant-padding-md) var(--ant-padding-lg);
    }

    .ant-modal-header {
      margin-bottom: 0;
      border-bottom: 1px solid var(--ant-color-border-secondary);
    }

    .ant-modal-body {
      padding-block: var(--ant-padding-lg);
    }

    .ant-modal-footer {
      margin-top: 0;
      padding-top: var(--ant-padding-md);
      border-top: 1px solid var(--ant-color-border-secondary);
    }

    &.app-modal-fullscreen {
      top: 0;
      width: 100%;
      max-width: 100%;
      height: 100vh;
      height: 100svh;
      max-height: 100dvh;
      box-sizing: border-box;
      overflow: hidden;
      margin: 0;
      padding-bottom: 0;

      .ant-modal-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 0;
        overflow: hidden;
        border-radius: 0;
      }

      .ant-modal-header,
      .ant-modal-footer {
        flex-shrink: 0;
      }

      .ant-modal-footer {
        padding-bottom: calc(
          var(--ant-padding-md) + env(safe-area-inset-bottom, 0px)
        );
      }

      .ant-modal-body {
        width: 100%;
        max-width: 1440px;
        margin-inline: auto;
        flex: 1;
        min-height: 0;
        overflow: auto;
        overscroll-behavior: contain;
      }
    }

    @media (max-width: 560px) {
      .ant-modal-body {
        padding-block: var(--ant-padding-md);
      }
    }
  `,
};

interface AppModalProps extends ModalProps {
  blocking?: boolean;
  /** Force fullscreen, or disable automatic fullscreen with false. */
  fullScreen?: boolean;
}

const AppModal = ({
  blocking = false,
  className,
  wrapClassName,
  fullScreen,
  mask,
  maskClosable,
  ...props
}: AppModalProps) => {
  const breakpoints = Grid.useBreakpoint();
  const resolvedFullScreen = fullScreen ?? !breakpoints.md;

  const resolvedMask =
    mask === false
      ? false
      : {
          ...(typeof mask === 'object' ? mask : {}),
          closable: blocking
            ? false
            : ((typeof mask === 'object' ? mask.closable : undefined) ??
              maskClosable),
        };

  return createElement(Modal, {
    ...props,
    className: classNames(styles.modal, className, {
      'app-modal-fullscreen': resolvedFullScreen,
    }),
    wrapClassName: classNames(wrapClassName, {
      [styles.fullscreenWrap]: resolvedFullScreen,
    }),
    width: resolvedFullScreen ? '100%' : props.width,
    centered: resolvedFullScreen ? false : props.centered,
    cancelButtonProps: {
      ...props.cancelButtonProps,
      disabled: blocking || props.cancelButtonProps?.disabled,
    },
    onCancel: blocking ? undefined : props.onCancel,
    closable: blocking ? false : props.closable,
    keyboard: blocking ? false : props.keyboard,
    mask: resolvedMask,
  });
};

export default AppModal;
